export const validateConstant = {
    GET_TAGS_FOR_VALIDATION_REQUEST: 'GET_TAGS_FOR_VALIDATION_REQUEST',
    GET_TAGS_FOR_VALIDATION_SUCCESS: 'GET_TAGS_FOR_VALIDATION_SUCCESS',
    GET_TAGS_FOR_VALIDATION_FAILURE: 'GET_TAGS_FOR_VALIDATION_FAILURE'
 };